<template>
  <div>
    <div v-if="isPC" class="feedback-dialog">
      <div class="feedback-dialog-main">
        <div class="feedback-dialog-header">
          <div class="dialog-header-container">
            <span class="dialog-header-title">
              {{ TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进") }}  
            </span>
          </div>
          <div @click="closeFeedbackModal">
            <Icon :file="DialogCloseIcon" width="20px" height="20px"/>
          </div>
        </div>

        <div class="dialog-select-container">
          <span class="dialog-session-title"> 
            {{ TUITranslateService.t("AIDesk.您遇到了哪方面的问题") }}  
          </span>
          <div class="dialog-button-list">
            <div class="dialog-button-row" v-for="(item) in feedbackButtonList">
              <div :class="['dialog-button',item.isSelected ? 'dialog-button-selected': '']" @click="dialogButtonClick(item)">
                {{ feedbackButtonListFromStore ? item.content : TUITranslateService.t(`AIDesk.${item.content}`) }}
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-other-feedback-container">
          <span class="dialog-session-title"> 
            {{ TUITranslateService.t("AIDesk.其他反馈内容") }}   
          </span>
          <textarea type="text" :placeholder="TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？')" maxlength="200" v-model="feedbackText" class="dialog-other-feedback-input"/>
        </div>
        <div class="dialog-foot">
          <div :class="isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled'" @click="submit"> 
            {{ TUITranslateService.t("AIDesk.提交") }}  
          </div>
          <div class="dialog-cancel" @click="closeFeedbackModal"> 
            {{ TUITranslateService.t("AIDesk.取消") }} 
          </div>
        </div>
      </div>
    </div>
    <div v-else class="edit-form">
      <div class="edit-form-item">
        <FormPopup
          class="form-item"
          :show="true"
          :showHeaderCloseButton="false"
          @onClose="closeFeedbackModal"
          title=""
        >
          <div class="dialog-title">
            <div class="dialog-header-title">
              {{ TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进") }}  
            </div>
            <Icon :file="DialogCloseIcon" width="16px" height="16px" @click="closeFeedbackModal"/>
          </div>
          <div class="dialog-select-container-h5">
            <span class="dialog-session-title"> 
              {{ TUITranslateService.t("AIDesk.您遇到了哪方面的问题") }}  
            </span>
            <div class="dialog-button-list">
              <div class="dialog-button-row" v-for="(item) in feedbackButtonList">
                <div :class="['dialog-button',item.isSelected ? 'dialog-button-selected': '']" @click="dialogButtonClick(item)">
                  {{ feedbackButtonListFromStore ? item.content : TUITranslateService.t(`AIDesk.${item.content}`) }}
                </div>
              </div>
            </div>
          </div>

          <div class="dialog-other-feedback-container-h5">
            <span class="dialog-session-title"> 
              {{ TUITranslateService.t("AIDesk.其他反馈内容") }}   
            </span>
            <textarea type="text" :placeholder="TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？')" maxlength="200" v-model="feedbackText" class="dialog-other-feedback-input"/>
          </div>
          <div class="dialog-foot-h5">
            <div :class="isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled'" @click="submit"> 
              {{ TUITranslateService.t("AIDesk.提交") }}  
            </div>
          </div>
        </FormPopup>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../adapter-vue';
import { vueVersion } from '../../../adapter-vue-web';
import Icon from '../../common/Icon.vue';
import TUIChatEngine, { StoreName, TUIStore, TUITranslateService, TUIChatService } from '../../../@aidesk/uikit-engine';
import GreenCheck from '../../../assets/green_check.svg';
import DialogCloseIcon from '../../../assets/dialog-close.png';
import { isPC } from '../../../utils/env';
import Log from "../../../utils/logger";
import { Toast, TOAST_TYPE } from "../../../components/common/Toast/index-web";
import FormPopup from '../message-list/message-elements/message-desk/message-desk-elements/message-multi-form/component-mobile/form-popup.vue';
import { CUSTOM_MESSAGE_SRC, FeedbackType } from "../../../constant";
const { ref, computed, onMounted, onUnmounted } = vue;

export default {
  components:{
    Icon,
    FormPopup,
  },
  setup(props, { expose, emit }){
    let _messageInfo = {};
    const feedbackText = ref('');
    const feedbackButtonList = ref([
      { id:'101', content: '答非所问', isSelected: false },
      { id:'102', content: '信息错误', isSelected: false },
      { id:'103', content: '格式不规范', isSelected: false },
      { id:'104', content: '内容不完整', isSelected: false },
      { id:'105', content: '未匹配相关内容', isSelected: false },
      { id:'106', content: '上下文理解错误', isSelected: false },
    ]);
    const feedbackButtonListFromStore = ref(false);
    // 点击关闭按钮或者取消，需要默认发送 dislike 请求
    const closeFeedbackModal = async () => {
      emit('close');
      await postFeedback(2, _messageInfo, false);
      resetFeedback();
    };

    const resetFeedback = () => {
      feedbackButtonList.value.forEach(item => {
        item.isSelected = false;
      });
      feedbackText.value = "";
    };

    const onFeedbackTags = (data) => {
      if (!data) {
        return;
      }
      feedbackButtonListFromStore.value = true;
      feedbackButtonList.value = data;
    };

    onMounted(() => {
      TUIStore.watch(StoreName.CUSTOM, {
        feedbackTags: onFeedbackTags
      });
    });

    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CUSTOM, {
        feedbackTags: onFeedbackTags
      });
    });

    const postFeedback = async (type, messageInfo, withReasons = false) => {
      Log.i(`postFeedback type:${type} messageInfo:`, messageInfo);
      let feedbackDetail = { 
        type,
        menuSelected: [],
        otherContent: '',
      };
      // 是否需要带上反馈原因（不带上就是默认点赞或者默认点踩）
      if (withReasons) {
        if (feedbackText.value) {
          feedbackDetail.otherContent = feedbackText.value;
        }
        feedbackDetail.menuSelected = feedbackButtonList.value.filter((item) => item.isSelected).map(item => ({ id: item.id, content: item.content }));
      }
      TUIChatService.sendCustomMessage({
        to: messageInfo.groupId ? messageInfo.groupId : messageInfo.toAccount,
        conversationType: messageInfo.groupId ? TUIChatEngine.TYPES.CONV_GROUP : TUIChatEngine.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify({
            src: CUSTOM_MESSAGE_SRC.SEND_FEEDBACK,
            customerServicePlugin: 0,
            feedbackDetail,
            messageInfo,
          }),
        },
      },{ onlineUserOnly: true});
    }

    const dialogButtonClick = (item) => {
      if (vueVersion === 3) {
        // vue 3 
        item.isSelected = !item.isSelected;
      } else {
        // vue 2.6 or vue 2.7
        const index = feedbackButtonList.value.findIndex(i => i.id === item.id);
        if (index === -1) return;
        const newList = feedbackButtonList.value.slice();
        newList[index] = {
          ...newList[index],
          isSelected: !newList[index].isSelected
        };
        feedbackButtonList.value = newList;
      }
    };

    const isSubmitEnabled = computed(() => {
      const selectedList = feedbackButtonList.value.filter((item) => item.isSelected);
      if (selectedList.length === 0 && feedbackText.value.trim() === '') {
        return false;
      }
      return true;
    });

    const submit = async () => {
      emit('close');
      await postFeedback(2, _messageInfo, true);
      feedbackToast();
      resetFeedback();
    };

    const feedbackToast = () => {
      Toast({
        message: TUITranslateService.t('AIDesk.提交成功'),
        type: TOAST_TYPE.SUCCESS,
        duration: 5000,
      });
    }

    const onLike = (type, messageInfo) => {
      postFeedback(type, messageInfo, false);
      if (type === FeedbackType.LIKE) {
        feedbackToast();
      }
    };

    const onDislike = (type, messageInfo) => {
      _messageInfo = messageInfo;
      if (type === FeedbackType.CANCEL_DISLIKE) {
        postFeedback(type, messageInfo, false);
      }
    };
    return {
      isPC,
      GreenCheck,
      DialogCloseIcon,
      feedbackButtonList,
      feedbackText,
      dialogButtonClick,
      TUITranslateService,
      closeFeedbackModal,
      submit,
      isSubmitEnabled,
      feedbackButtonListFromStore,
      onLike,
      onDislike,
    };
  }
}
</script>
<style lang="scss">
.feedback-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(13, 17, 26, 0.4);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  &-main {
    box-sizing: border-box;
    width: 400px;
    min-height: 442px;
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    overflow: hidden;
    .feedback-dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;
      .dialog-header-container {
        display: flex;
        gap: 8px;
        align-items: center;
        .dialog-header-title {
          font-weight: 600;
          font-size: 16px;
        }
      }
    }
  }
}
.dialog-session-title {
    color: #4D586D;
    font-size: 12px;
}
.dialog-select-container, .dialog-select-container-h5 {
  margin-top: 20px;
  .dialog-button-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
    .dialog-button-row {
      flex: 0 0 48%;
      min-width: 0;
      .dialog-button {
        border-radius: 8px;
        border: 1px solid #E4E8EF;
        background: #F9FAFC;
        padding: 4px 16px;
        display: flex;
        justify-content: center;
        font-size: 12px;
        color: #0f1014;
        cursor: pointer;
        text-align: center;
        align-items: center;
        min-height: 30px;
        height: 100%;
        &-selected {
          border-radius: 8px;
          border: 1px solid #1C66E5;
          background: rgba(28, 102, 229, 0.10);
          color: #0052d9;
        }
      }
    }
  }
}
.dialog-select-container-h5 {
  padding: 0 20px;
  margin-top: 0;
}
.dialog-other-feedback-container, .dialog-other-feedback-container-h5 {
  margin: 20px 0 10px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .dialog-other-feedback-input {
    border-radius: 12px;
    border: 1px solid #E4E8EE;
    background: #F9FAFC;
    height: 75px;
    padding: 12px;
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    resize: none;
    &::placeholder {
      color: var(---Black-6, rgba(0, 0, 0, 0.25));
      font-size: 12px;
    }
  }
}
.dialog-other-feedback-container-h5 {
  padding: 0 20px;
}
.dialog-foot {
  width: 100%;
  display: flex;
  margin-top: 15px;
  gap: 20px;
  justify-content: center;
  .dialog-submit {
    padding: 9px 33px;
    border-radius: 20px;
    background: #1C66E5;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
  }
  .disabled {
    background: #C0E4FF;
    color: #fff;
    cursor: not-allowed;
  }
  .dialog-cancel {
    padding: 9px 33px;
    border-radius: 20px;
    border: 1px solid #1C66E5;
    font-weight: 500;
    color: #1C66E5;
    cursor: pointer;
  }
}
.dialog-foot-h5 {
  padding: 20px;
  .dialog-submit {
    padding: 9px 33px;
    border-radius: 20px;
    background: #1C66E5;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    text-align: center;
  }
  .disabled {
    background: #C0E4FF;
    color: #fff;
    cursor: not-allowed;
  }
}
.dialog-title {
  gap: 10px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
</style>